import { faCalendarPlus, faChevronDown, faChevronUp, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chance } from 'chance';
import moment from 'moment/moment';
import { Component } from 'react';
import { Button, Container, Spinner } from 'react-bootstrap';
import { DateRangePicker } from 'react-date-range';
import { connect } from 'react-redux';
import { POST } from '../../api/index';
import { FrenchRose, Gray, White } from '../../helpers/brand_colors_helper';
import GeneralCard from '../../helpers/GeneralCard';
import { withParams } from '../../helpers/params_helper';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
import { t } from '../../helpers/translation_helper';
import Header from '../_partials/Header/_Header';
import NavBar from '../_partials/NavBar/_NavBar';
import AcademicActivityReflection from '../Dashboard/AcademicActivityReflection';
const chance = new Chance();

const apiURL = process.env.REACT_APP_API_URL;
const portalURL = process.env.REACT_APP_PORTAL_URL;

const defaultTimelineTypes = [
    {
        uid: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
        label: "Activity",
        ut_type: "Academic Activity",
        picture: require('../../assets/images/user-timeline/activity.png'),
        active: true,
    },
]
/**
 * Activities Component
 */
class Activities extends Component {
    // State
    state = {
        getUserTimelineData: {
            refreshing: false,
            finished: false,
            limit: 12,
            offset: 0,
            data: [],
            totalRecords: 0,
        },
        filter: {
            show: false,
            toggleFilter: (show) => this.setState({ filter: { ...this.state.filter, show: (this.state.filter.show == show) ? false : show } }),
            setData: (key, value) => {
                this.setState({ filter: { ...this.state.filter, [key]: value } })
            },
            selectedUT: defaultTimelineTypes.map((v, i) => { return { label: v.name, value: v.ut_type } }),
            selectedDateRange: { startDate: new Date(moment().subtract(6, 'month')), endDate: new Date(), key: 'selection' },
            keyword: '',
        },
        academicActivityReflectionModal: {
            show: false,
            modalTitle: 'Assignment',
            data: null,
            closeModal: () => this.setState({ academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: false } }),
            toggleModal: (modalTitle = null, data = null) => this.setState({
                academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: !this.state.academicActivityReflectionModal.show, modalTitle, data }
            }),
            showModal: () => this.setState({ academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: true } }),
        },
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        this.refreshUserTimeline();
    }

    getUserTimeline = () => {

        const { authData, selectedChild } = this.props;
        const { class_id, child_id } = selectedChild;

        if (this.state.getUserTimelineData.refreshing) {
            return false
        }
        if (this.state.getUserTimelineData.finished) {
            return false
        }

        this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, refreshing: true } }, () => {

            if (this.getUserTimelineRequest) {
                this.getUserTimelineRequest.abort()
            }
            this.getUserTimelineRequest = new AbortController();

            let userTimelineDataLen = this.state.getUserTimelineData.data.length

            let fData = new FormData()
            fData.append('selectedTimelineTypes', JSON.stringify(this.state.filter.selectedUT.map((v, i) => { return { ut_type: v.value, active: true } })))
            fData.append('offset', (userTimelineDataLen > 0) ? this.state.getUserTimelineData.offset : 0)
            fData.append('limit', this.state.getUserTimelineData.limit)
            fData.append('user_id', this.props.authData.loginData.user_id)
            fData.append('child_id', child_id)
            fData.append('class_id', class_id)
            fData.append('center_id', this.props.authData.centerData.center_id)
            fData.append('center_timezone', this.props.authData.centerData.center_timezone)
            fData.append('ut_id', (userTimelineDataLen > 0) ? this.state.getUserTimelineData.data[userTimelineDataLen - 1].ut_id : 0)
            fData.append('activeFilterDateFrom', (this.state.filter.selectedDateRange.startDate) ? moment(this.state.filter.selectedDateRange.startDate).format('YYYY-MM-DD') + ' 00:00:00' : null)
            fData.append('activeFilterDateTo', (this.state.filter.selectedDateRange.endDate) ? moment(this.state.filter.selectedDateRange.endDate).format('YYYY-MM-DD') + ' 23:59:59' : null)


            POST('user-timeline', fData, {
                params: {
                    auth_key: this.props.authData.loginData.auth_key,
                },
                signal: this.getUserTimelineRequest.signal,
            })
                .then((res) => {
                    console.log('getUserTimelineRequest', res);
                    if (res) {
                        let resData = res.data
                        if (resData.length <= 0) {
                            this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, refreshing: false, finished: true, offset: this.state.getUserTimelineData.offset + this.state.getUserTimelineData.limit } })
                            return
                        }
                        this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, data: this.state.getUserTimelineData.data.concat(resData), refreshing: false, finished: false, offset: this.state.getUserTimelineData.offset + this.state.getUserTimelineData.limit } })
                    }
                })

        })

    }
    refreshUserTimeline = () => {
        this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, data: [], refreshing: false, finished: false, offset: 0 }, filter: { ...this.state.filter, show: false } }, () =>
            this.getUserTimeline()
        )
    }

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        // Language Direction
        const { lang_orientation: dir } = this.props.defaultLanguage;

        // State
        const { getUserTimelineData, academicActivityReflectionModal } = this.state;

        return (
            <Container fluid>
                <div id='iedu-layout'>
                    <NavBar />
                    <div id='page-content'>
                        <Header lite={true} heading={'Activities'} backBtn={true} showChildSelector={true} func={[this.refreshUserTimeline]} />

                        {/* FILTER BAR */}
                        <div className="filter-bar class-view-filter-bar">
                            {/* DATE */}
                            <div className="filter filter-date" >
                                <div className="filter-trigger" onClick={() => this.state.filter.toggleFilter('date_range_picker')}>
                                    <FontAwesomeIcon
                                        icon={(this.state.filter.show == 'date_range_picker') ? faChevronUp : faChevronDown}
                                        color={Gray}
                                        className="filter-arrow"

                                    />
                                    <strong className="filter-title">{t('Date Range')}</strong>
                                    <span className="selected-types">{moment(this.state.filter.selectedDateRange.startDate).format('DD-MM-YYYY')} -- {moment(this.state.filter.selectedDateRange.endDate).format('DD-MM-YYYY')}</span>
                                </div>
                                {(this.state.filter.show == 'date_range_picker')
                                    && <div className='filter-box' style={{ display: (this.state.filter.show == 'date_range_picker') ? 'initial' : 'none' }}>
                                        <DateRangePicker
                                            ranges={[this.state.filter.selectedDateRange]}
                                            onChange={(date) => {
                                                this.state.filter.setData('selectedDateRange', { startDate: new Date(date.selection.startDate), endDate: new Date(date.selection.endDate), key: 'selection' })
                                            }}
                                            // className='filter-date-picker'
                                            style={{ backgroundColor: '#fff' }}
                                        />
                                    </div>
                                }
                            </div>
                            {/* BTN SEARCH */}
                            <div className="filter-btn d-flex align-items-center" style={{ marginLeft: 10 }}>
                                <button type="button" className="btn btn-primary" id="btn_filter_modal_apply" style={{ width: 50, height: 50, textAlign: 'center' }} onClick={() => {
                                    this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, data: [], refreshing: false, finished: false, offset: 0 }, filter: { ...this.state.filter, show: false } }, () =>
                                        this.getUserTimeline()
                                    )
                                }}>
                                    {this.state.getUserTimelineData.refreshing ? (
                                        <Spinner size='sm' animation='grow' variant='light' />

                                    ) : <FontAwesomeIcon
                                        icon={faSearch}
                                        color={White}
                                        style={{ fontSize: '24px', }}
                                    />}
                                </button>
                            </div>
                        </div>

                        {getUserTimelineData.data.length > 0 ? (
                            <div className='d-flex flex-row flex-wrap'>
                                {getUserTimelineData.data.map((v, index) => {
                                    let data = {
                                        allData: v,
                                        name: v.ut_title,
                                        status: { bg: 'secondary', name: moment(v.created_on).format('DD, MMM, YYYY') },
                                        text1: (v.academic_classmain_subject) ? v.academic_classmain_subject.map((vv) => vv.acs_name).join(',') : '',
                                        description: v.ut_description,
                                        cardImage: (v.academic_activities.aa_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activities/' + v.academic_activities.aa_image : require('../../assets/images/noimage.png'),
                                        actions: [
                                            {
                                                onClick: () => academicActivityReflectionModal.toggleModal(v.ut_title, v),
                                                name: 'Details & Reflections',
                                                iconName: faCalendarPlus,
                                                iconColor: FrenchRose,
                                            },
                                        ]
                                    }
                                    return <GeneralCard data={data} key={index} />;
                                }
                                )}
                            </div>
                        ) : (
                            null
                        )}
                        <div className="d-grid gap-2">
                            <Button variant="light" style={{ borderRadius: 20 }} onClick={() => this.getUserTimeline()} disabled={(getUserTimelineData.finished)}>
                                {getUserTimelineData.refreshing ? (
                                    <Spinner size='sm' animation='grow' variant='light' />
                                ) : (
                                    <>
                                        {(getUserTimelineData.finished) ? t('No more activities found!') : t('Load More')}
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                </div>

                {/* ACADEMIC ACTIVITY REFLECTION MODAL */}
                <AcademicActivityReflection academicActivityReflectionModal={this.state.academicActivityReflectionModal} />
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    languages: state.language.languages,
    defaultLanguage: state.language.defaultLanguage,
});
export default connect(mapStateToProps, null)(withParams(Activities));
